import { RoutesEnum } from 'models/enums/apiRoutes/commonRoutes';
import {
  IApiBaseResponse,
  IDynamicPricingAllData,
  IUserDynamicPricingData,
} from 'models/interfaces/Iglobal';
import axiosClient from 'sharedServices/api/axios.services';

class DynamicPricingServices {
  public getUserDynamicPricing = async (lister_id?: string) => {
    return axiosClient.get<IApiBaseResponse<IDynamicPricingAllData>>(
      RoutesEnum.USER_DYNAMIC_PRICING_DETAILS,
      {
        params: {
          lister_id,
        },
      },
    );
  };

  public getDefaultDynamicPricingRules = async () => {
    return axiosClient.get<IApiBaseResponse<IDynamicPricingAllData>>(
      RoutesEnum.DEFAULT_DYNAMIC_PRICING_RULES,
    );
  };

  public addOrModifyDynamicPricingRules = async (
    userDynamicPricingNewData: IUserDynamicPricingData,
  ) => {
    return axiosClient.put<IApiBaseResponse<IDynamicPricingAllData>>(
      RoutesEnum.SAVE_OR_MODIFY_DYNAMIC_PRICING_RULES,
      userDynamicPricingNewData,
    );
  };
}

export { DynamicPricingServices };
